import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Table, Badge } from 'react-bootstrap';
import { FormGroup, FieldGroup, TextInput, RadioButton, CurrencyInput, InputGroup, DateInput, FormTitleTooltip, DropDown } from '../../../../../../../../components/form/form'
import { getParticipantRoles } from '../../../../../../../../helpr/issueParticipantsFormData';
import Participant from '../../../../../../../../models/issueParticipant';
import closeBtn from '../../../../../../../../assets/close.svg';


import CreateIssueParticipantForm from './create-issue-participant-form';
import EditIssueParticipantForm from './edit-issue-participant-form';

import styles from './issue-participant.module.scss';
import {toCurrency} from '../../../../../../../../helpr/helper';
import { useValidation } from '../../../../../../../../hooks/use-validation';
import { roleTranslations } from '../../../../../../../../helpr/participantDataTranslations';
import { participantObj, participantValidator } from '../../../../../../../../form-control/listing-form/participant-form-control';

import addButton from '../../../../../../../../assets/add-button-colored.svg';

const IssueParticipant = ({ isPublished, curInstitution, securityList, issueParticipantList, setIssueParticipantList, requiredParticpants, nextStep }) => {
  console.log(issueParticipantList);
  const [ mode, setMode ] = useState('CREATE');
  const [ showForm, setShowForm ] = useState(false);
  const [ participantRoleBuffer, setParticipantRoleBuffer ] = useState(isPublished? 'MarketMaker' : '');
  const [ curListIndex, setCurListIndex ] = useState(issueParticipantList.length - 1);
  const participantFormState = useValidation( participantValidator, participantObj(new Participant()), {border: '1px solid red'} );
  const { forceSetField, forceSetFieldDynamic, getField } = participantFormState;
  const [ roleBadges, setRoleBadges ] = useState(requiredParticpants);
  const [ isEditable, setIsEditable ] = useState(true);

  const headers = [
    '',
    'Role',
    'Institution',
    'Primary Contact',
    'Title/Designation',
    'Email',
    'Telephone Number',
    'Address',
    'Allocation',
  ]

  useEffect(()=>{
    let badgesRolesKeys = Object.keys(roleBadges);
    let roleBadgesStatus = {};
    badgesRolesKeys.forEach(data=>{
      roleBadgesStatus[data] = 'secondary'
    })
    for(let index in issueParticipantList){
      if(badgesRolesKeys.includes(issueParticipantList[index].role)){
        roleBadgesStatus[issueParticipantList[index].role] = 'info';
      }
    }
    setRoleBadges(roleBadgesStatus);
  },[showForm, issueParticipantList])

  const selectRole = (e) =>  {
    const value = e.target.value
    setParticipantRoleBuffer(value);
  };

  const nextHandler = (step) => {
    /*
      Remove unsaved participant in listing info
    */
    for( let i in issueParticipantList ) {
      issueParticipantList[i].edit = false;
      if( issueParticipantList[i].save === false ) {
        removeRow(i);
      }
    }
    nextStep(step);
  }

  const removeRow = (index) => {
    let array = [ ...issueParticipantList ];
    array.splice(index, 1);
    setIssueParticipantList(array);
  }

  const setFormValue = (formValue) => {
    if(formValue['role'] === 'SellingAgent'){
      forceSetFieldDynamic('allocation', formValue['allocation']);
    }
    if(formValue['role'] === 'MarketMaker'){
      forceSetField('securitySubscription', formValue['securitySubscription']);
    }
    forceSetField('id', formValue['id']);
    forceSetField('role', formValue['role']);
    forceSetField('institutionName', formValue['institutionName']);
    forceSetField('primaryContactLastName', formValue.primaryContact['lastName']);
    forceSetField('primaryContactFirstName', formValue.primaryContact['firstName']);
    forceSetField('primaryContactMiddleInitial', formValue.primaryContact['middleInitial']);
    forceSetField('addressStreetAddress', formValue.address['street']);
    forceSetField('addressDistrictOrTown', formValue.address['districtOrTown']);
    forceSetField('addressCity', formValue.address['city']);
    forceSetField('addressStateProvinceRegion', formValue.address['stateProvinceRegion']);
    forceSetField('addressCountry', formValue.address['country']);
    forceSetField('addressZipCode', formValue.address['zipCode']);
    forceSetField('preferredSalutation', formValue['preferredSalutation']);
    forceSetField('title', formValue['title']);
    forceSetField('telephoneNumber', formValue['telephoneNumber']);
    forceSetField('emailAddress', formValue['emailAddress']);
    setShowForm(true);
  }

  const editRow = (index) => {
    /*
      Remove ability to edit if role is not selling agent once the
      termsheet is already published
    */
    if(issueParticipantList[index].role !== 'SellingAgent' && !issueParticipantList[index].isDeletable ){
      // Exit
      return
    }

    // Remove Unfilled-up Participant Obj Buffer
    for( let i in issueParticipantList ) {
      issueParticipantList[i].edit = false;
      if( issueParticipantList[i].save === false ) {
        removeRow(i);
      }
    }

    if( issueParticipantList[index].role !== 'RegistrarPayingAgent' ){
      setMode('EDIT');
      setCurListIndex(index);
      setParticipantRoleBuffer(issueParticipantList[index].role);
      issueParticipantList[index].edit = true;
      setFormValue(issueParticipantList[index]);
      setIsEditable(issueParticipantList[index].isDeletable);
    }
  }

  const cancelEdit = (index) => {
    setMode('ADD');
    setShowForm(false);
    setCurListIndex(issueParticipantList.length - 1);
    issueParticipantList[index].edit = false;
  }

  const toTitleCase = (str) => {
    return str.replace(/\w\S*/g, function(txt){
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  const buildAddress = (data) => {
    return data['address'].street + ', ' + data['address'].districtOrTown + ' ' + data['address'].city + ' '
         + data['address'].stateProvinceRegion + ' '  + data['address'].country
  }

  const buildPrimaryContactName = (data) => {
    return toTitleCase(data['primaryContact'].lastName) + ', ' + toTitleCase(data['primaryContact'].firstName) + ' '
         + data['primaryContact'].middleInitial.toUpperCase() + '.'
  }

  const renderRequiredBadges = () => {
    let badgesRolesKeys = Object.keys(roleBadges);
    return (
      <div className={styles['required-participants']}>
        {
          badgesRolesKeys.map((item,index)=>{
            return (
              <Badge key={'badge-'+index} variant={roleBadges[item]}>{item}</Badge>
            )
          })
        }
      </div>
    )
  }

  const validateRequired = () => {
    let badgesRolesKeys = Object.keys(roleBadges);
    let roleBadgesStatus = {}
    badgesRolesKeys.map((data,_)=>{
      if(data !== ''){ roleBadgesStatus[data] = 'danger' }
    })
    for(let index in issueParticipantList){
      if(badgesRolesKeys.includes(issueParticipantList[index].role)){
        roleBadgesStatus[issueParticipantList[index].role] = 'info';
      }
    }
    if(Object.values(roleBadgesStatus).includes('danger')){
      setRoleBadges(roleBadgesStatus);
    } else {
      // Clear Unsaved
      for( let i in issueParticipantList ) {
        issueParticipantList[i].edit = false;
        if( issueParticipantList[i].save === false ) {
          removeRow(i);
        }
      }
      nextStep();
    }
  }

  const renderTableSummary = () => {
    return (
      <>
        <div>
          <Table className='mt-1' responsive>
            <thead>
              <tr>
                {headers.map((header, index)=>{
                  return <th key={'table-'+index}>{header}</th>})}
              </tr>
            </thead>
            <tbody>
              {issueParticipantList.map((data, index)=>{
                if( data['save'] ){
                  return (
                    <tr key={'participant-'+index}>
                      { data['edit'] }
                      <td>
                        { data['role'] === 'RegistrarPayingAgent' || data['edit'] || isPublished ? '' :
                         <img className={styles['close-button']} onClick={()=>removeRow(index)} src={closeBtn}/>}
                      </td>
                      <td className={`${styles['table-col']} ${styles['def-width']}`} onClick={()=>editRow(index)}>{ roleTranslations(data['role']) }</td>
                      <td className={`${styles['table-col']} ${styles['def-width-2']}`} onClick={()=>editRow(index)}>{ data['institutionName'] }</td>
                      <td className={`${styles['table-col']} ${styles['def-width']}`} onClick={()=>editRow(index)}>{ buildPrimaryContactName(data) }</td>
                      <td className={styles['table-col']} onClick={()=>editRow(index)}>{ data['title'] }</td>
                      <td className={styles['table-col']} onClick={()=>editRow(index)}>{ data['emailAddress'] }</td>
                      <td className={styles['table-col']} onClick={()=>editRow(index)}>{ data['telephoneNumber'] }</td>
                      <td className={`${styles['table-col']} ${styles['def-width-3']}`} onClick={()=>editRow(index)}>{ buildAddress(data) }</td>
                      <td className={`${styles['table-col']} ${styles['def-width-3']}`} onClick={()=>editRow(index)}>{
                        (data['allocation'] === null || data['allocation'] === undefined) ? 'N/A' : data['allocation'].map((alloc, _)=>{
                          if(data['allocation'].length !== 0){
                            if(alloc['securityIndex']!=='' && alloc['amount']!==''){
                              if(parseInt(alloc['securityIndex'])<securityList.length){
                                return ' '+securityList[parseInt(alloc['securityIndex'])]['prefShortName'] + ' - ' + toCurrency(alloc['amount'].toString())
                              } else { return '-' };
                            }
                          }
                          return 'N/A';
                        })
                      }</td>
                    </tr>
                  )
                }
              })}
            </tbody>
          </Table>
        </div>
          <Row>
            <Col>
              <div className={styles['required-participants']}>
                { renderRequiredBadges() }
              </div>
            </Col>
          </Row>
      </>
    )
  }

  const saveParticipantDetail = (index, participant) => {
    const ROLE = participantRoleBuffer === 'Custom'? 'Custom-'+participant.role: participant.role;
    issueParticipantList[index] = new Participant({
      id: participant.id,
      institutionName: participant.institutionName,
      role: ROLE,
      allocation: participant.allocation,
      securitySubscription: participant.securitySubscription,
      primaryContact: {
        lastName: participant.primaryContactLastName,
        firstName: participant.primaryContactFirstName,
        middleInitial: participant.primaryContactMiddleInitial
      },
      preferredSalutation: participant.preferredSalutation,
      title: participant.title,
      address: {
        street: participant.addressStreetAddress,
        districtOrTown: participant.addressDistrictOrTown,
        city: participant.addressCity,
        stateProvinceRegion: participant.addressStateProvinceRegion,
        country: participant.addressCountry,
        zipCode: participant.addressZipCode
      },
      telephoneNumber: participant.telephoneNumber,
      emailAddress: participant.emailAddress,
      edit: false,
      save: true,
      isDeletable: issueParticipantList[index].isDeletable
    });
    setIssueParticipantList(issueParticipantList);
    setShowForm(false);
    setParticipantRoleBuffer('');
  }

  const addParticipant = () => {
    if(isPublished){setParticipantRoleBuffer('MarketMaker')};
    issueParticipantList.push(new Participant())
    setMode('CREATE');
    setCurListIndex(issueParticipantList.length-1);
    setShowForm(true);
  }

  const renderParticipantInfo = () => {
    if( showForm ){
      if( mode === 'CREATE' ) {
        return (
          <FormGroup header="ADD ISSUE PARTICIPANT">
            <Row>
              <Col sm={6} lg={4}>
                <DropDown inputProps={{value: participantRoleBuffer, onChange: selectRole}} values={getParticipantRoles()} disabled={isPublished}>
                  Participant Role:*
                </DropDown>
              </Col>
            </Row>
            <CreateIssueParticipantForm
                index={curListIndex}
                curInstitution={curInstitution}
                securityList={securityList}
                participantFormState={participantFormState}
                participantRole={participantRoleBuffer}
                saveParticipant={saveParticipantDetail}/>
          </FormGroup>
        )
      }
      if( mode === 'EDIT') {
        return (
          <FormGroup header={"EDIT "+roleTranslations(getField('role'))}>
            <EditIssueParticipantForm
              index={curListIndex}
              isEditable={isEditable}
              securityList={securityList}
              participantFormState={participantFormState}
              participantRole={participantRoleBuffer}
              saveParticipant={saveParticipantDetail}
              cancelEdit={cancelEdit}/>
          </FormGroup>
        )
      }
    } else {
      return (
        <div className={styles['btn-actions']}>
          <div onClick={()=>addParticipant()} className={styles['add-btn']}>
            <img src={addButton}/>
          </div>
        </div>
      )
    }
  }

  return (
    <div className={styles['issue-participant-component']}>
      <Row>
        <Col>
          <FormGroup header="SUMMARY">
            { renderTableSummary() }
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          { renderParticipantInfo() }
        </Col>
      </Row>
      <Row className={styles['btn-actions']}>
        <Button onClick={()=>nextHandler(true)} className="btn-secondary">BACK</Button>
        <Button onClick={()=>validateRequired()}>NEXT</Button>
      </Row>
    </div>
  )


}


export default IssueParticipant;





